import React from 'react'
import { PhoneInputProps } from 'src/shared/components/phone-input'
import {
  PhoneNumberFieldUi,
  PhoneNumberFieldUiStylesInterface,
} from './ui/phone-number-field-ui'

export interface PhoneNumberFieldNewProps
  extends PhoneNumberFieldUiStylesInterface,
    PhoneInputProps {}

export const PhoneNumberFieldNew = (props: PhoneNumberFieldNewProps) => {
  return <PhoneNumberFieldUi {...props} />
}
